import React from "react";
import { useNavigate } from 'react-router-dom';
import { ConuntryComponent, CountryInformation } from "./style";

const Country = ({ flagUrl, countryName, population, region, capital, isDarkMode }) => {
    const numberFormatter = new Intl.NumberFormat('en-US');
    const navigate = useNavigate();

    const handleClick = () => {
      navigate(`/country/${countryName}`);
    };

    const formattedPopulation = numberFormatter.format(population);

    return (
        <ConuntryComponent onClick={handleClick} isDarkMode={isDarkMode}>
            <div className="Country-img">
                <img src={flagUrl} alt={countryName} />
            </div>
            <CountryInformation isDarkMode={isDarkMode}>
                <h2>{countryName}</h2>
                <p><b>Population:</b> <span>{formattedPopulation}</span></p>
                <p><b>Region:</b> <span>{region}</span></p>
                <p><b>Capital:</b> <span>{capital}</span></p>
            </CountryInformation>
        </ConuntryComponent>
    );
};

export default Country;